import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { memo, useCallback } from 'react';
import { DateRangeField } from './date-range';

export const OrderCreateTimeRangeField = memo(() => {
  const { form } = useOrderSearchForm();

  const onLowerChange = useCallback(
    (value: string | undefined) => {
      form.createdAt.update({
        ...form.createdAt.value,
        start: value,
        startInclusive: value == null ? undefined : true,
      });
    },
    [form.createdAt],
  );

  const onUpperChange = useCallback(
    (value: string | undefined) => {
      form.createdAt.update({
        ...form.createdAt.value,
        end: value,
        endInclusive: value == null ? undefined : true,
      });
    },
    [form.createdAt],
  );

  return (
    <DateRangeField
      value={form.createdAt.value}
      label="建单时间"
      onLowerChange={onLowerChange}
      onUpperChange={onUpperChange}
    />
  );
});
